import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../loader";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTranslation } from "react-i18next";
import PreferenceSettings from "./PreferenceSettings";
import DynamicBreadcrumbs from "../shared/DynamicBreadcrumbs";

const Preferences = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navHome = () => {
    navigate('/');
  };

  return (
    <>
      <Loader />

      <AppBar className="headerMain" id="tagsNavbar">
        <Grid container className="marginRow" spacing={1.4}>
          <Grid item md={6} sm={6} xs={6}>
            <div style={{ fontSize: "14px", paddingLeft: "0px", paddingTop: "26px" }}>
              <DynamicBreadcrumbs onHome={navHome} />
            </div>
          </Grid>
        </Grid>
      </AppBar>

      <Container className="container-fluid p-0" maxWidth="xl">
        <PreferenceSettings />
      </Container>
    </>
  );
};

export default Preferences;
